import {
    ArrivalHallProperties,
    BoardingGateProperties,
    CheckInProperties,
    DepartureHallProperties,
    ParkingProperties,
    Resource,
    TerminalProperties,
} from '../../../../../../../backend';

export const isBoardingGateProperties = (content: Resource['content']): content is BoardingGateProperties => {
    return (content as BoardingGateProperties).type === 'BoardingGateProperties';
};
export const isCheckInProperties = (content: Resource['content']): content is CheckInProperties => {
    return (content as CheckInProperties).type === 'CheckInProperties';
};
export const isArrivalHallProperties = (content: Resource['content']): content is ArrivalHallProperties => {
    return (content as ArrivalHallProperties).type === 'ArrivalHallProperties';
};
export const isDepartureHallProperties = (content: Resource['content']): content is DepartureHallProperties => {
    return (content as DepartureHallProperties).type === 'DepartureHallProperties';
};
export const isParkingProperties = (content: Resource['content']): content is ParkingProperties => {
    return (content as ParkingProperties).type === 'ParkingProperties';
};
export const isTerminalProperties = (content: Resource['content']): content is TerminalProperties => {
    return (content as TerminalProperties).type === 'TerminalProperties';
};
